export default "__VITE_ASSET__51eb6122__"